import Cookies from "js.cookie/js.cookie";

Pixlee.module('Components.NavbarMobile', function(NavbarMobile, App, Backbone, Marionette, $) {
    var _this = this,
        API;

    NavbarMobile.Layout = App.Views.Layout.extend({
        template: require('./templates/layout.jst.ejs'),
        id: 'interactive_section',
        regions: {
            searchRegion: '#search_region',
            locationRegion: '#location_region',
            mapRegion: '#map_region',
            resultsBarRegion: '#results_bar_region'
        },
        ui: {
            mobileButton: '#mobile_button'
        },
        events: {
            'click #mobile_button': 'showInteractiveMobileLightbox',
            'click #location_region': 'showDropDown',
            'click #search_region': 'showSearch'
        },
        initialize: function() {
            this.firstLoad = true;
            this.fetchCount = 0;
        },
        showInteractiveMobileLightbox: function(initialFilters) {
            var _this = this;
            var msg;

            $.magnificPopup.open({
                fixedContentPos: true,
                mainClass: 'mobile_navbar_lightbox',
                items: {
                    src: '#mobile_navbar_lightbox',
                    type: 'inline'
                },
                callbacks: {
                    beforeOpen: function() {
                        this.beforeScrollY = window.scrollY || 0;
                        $('html').addClass('mfp-helper');
                    }.bind(this),
                    open: function() {
                        msg = {
                            name: 'pixlee:interactive:widget:resize',
                            type: 'action',
                            source: 'widget',
                            destination: 'parent',
                            data: {
                                active: true,
                                isPreview: gon.previewMode
                            }
                        };
                        window.parent.postMessage(JSON.stringify(msg), '*');

                        setTimeout(function() {
                            var lightbox = _this.rm.addRegion('lightbox', '#mobile_navbar_lightbox');
                            _this.trigger('create:interactive:lightbox', lightbox, initialFilters);
                        }, 100);

                        msg = {
                            name: 'pixlee:interactive:widget:mobile:scroll:top:fix',
                            type: 'action',
                            source: 'widget',
                            destination: 'parent',
                            data: {}
                        };
                        top.postMessage(JSON.stringify(msg), '*');

                    }.bind(this),
                    close: function() {
                        $('html').removeClass('mfp-helper');
                        $('#mobile_navbar_lightbox').off('click');

                        this.trigger('close:lightbox');
                        this.rm.removeRegion('lightbox');

                        if (this.beforeScrollY > 0) {
                            window.scrollTo(window.scrollX, this.beforeScrollY);
                        }
                    }.bind(this)
                }
            });
        },
        getParameterByName: function(name, url) {
            name = name.replace(/[\[]/, '\\\[').replace(/[\]]/, '\\\]');
            var regex = new RegExp('[\\?&]' + name + '=([^&#]*)'),
                results = regex.exec(url);
            return results === null ? null : decodeURIComponent(results[1].replace(/\+/g, ' '));
        },
        resizeDone: function() {
            var navbarModel = this.model;
            // reset the width to the size of the mobile device screen to stop iFrame Resizer expanding
            if (navbarModel.get('widgetType') === 'horizontal' || navbarModel.get('widgetType') === 'coverflow') {
                var msg = {
                    name: 'pixlee:interactive:widget:mobile:horizontal',
                    type: 'action',
                    source: 'widget',
                    destination: 'parent',
                    data: {}
                };

                window.parent.postMessage(JSON.stringify(msg), '*');
            }
            this.ui.mobileButton.removeClass('disabled');
            if (navbarModel.get('search')) {
                this.searchRegion.$el.removeClass('disabled');
            }
            if (navbarModel.get('location')) {
                this.locationRegion.$el.removeClass('disabled');
            }
        },
        disableButtons: function() {
            var navbarModel = this.model;
            this.ui.mobileButton.addClass('disabled');
            if (navbarModel.get('search')) {
                this.searchRegion.$el.addClass('disabled');
            }
            if (navbarModel.get('location')) {
                this.locationRegion.$el.addClass('disabled');
            }
        },
        onShow: function() {
            var _this = this;
            var collection = App.widget.currentView.collection;
            this.rm = new Marionette.RegionManager();
            // If we are not using iFrame resizer don't disable buttons (stand alone)
            if (document.querySelector('iframe[id*=pixlee_widget_iframe]')) {
                this.disableButtons();
            }

            //check if there's any initial filters requested, and set them
            var initialFilters = this.getParameterByName('filters', window.location.href);
            if (initialFilters) {
                this.showInteractiveMobileLightbox(initialFilters);
            }

            collection.once('sync', function() {
                var collection = App.widget.currentView.collection;
                _this.initialUrl = collection.url();
            });
            $(document).click(function(e) {
                if (!$(e.target).hasClass('load_more') && !$(e.target).hasClass('img_holder')) {
                    _this.hideDropDowns(e);
                }
            });
            $(window).resize(_.debounce(this.disableButtons.bind(this), 600, true));
            $(window).resize(_.debounce(this.resizeDone.bind(this), 400));
        },
        onHideLocationRegion: function() {
            var _this = this;
            this.model.set('location_active', false);
            this.showLoader();
            this.mapRegion.$el.removeClass('active');
            this.mapRegion.$el.one('transitionend webkitTransitionEnd oTransitionEnd otransitionend MSTransitionEnd', function() {
                _this.onSync();
            });
        },
        onShowLocationRegion: function() {
            var _this = this;
            this.model.set('location_active', true);
            this.showLoader();
            this.mapRegion.$el.addClass('active');
            this.mapRegion.$el.one('transitionend webkitTransitionEnd oTransitionEnd otransitionend MSTransitionEnd', function() {
                _this.onSync();
            });
        },
        showDropDown: function(e) {
            e.stopPropagation();
            var active = $(e.currentTarget).hasClass('active');
            if ($(e.target).closest('.filter_dropdown').length === 0) {
                this.hideDropDowns();
            }
            if (!active) {
                var analyticsId = e.currentTarget.getAttribute('analytics-id');
                this.trigger('analytics:track', 'Click Interactive Bar', analyticsId, 'interacted');
                if (e.currentTarget.id === 'location_region' && !this.model.get('location_active')) {
                    this.triggerMethod('show:location:region');
                    this.trigger('render:map:markers');
                } else if (e.currentTarget.id === 'location_region' && this.model.get('location_active')) {
                    this.triggerMethod('hide:location:region');
                } else {
                    $(e.currentTarget).addClass('active');
                }
            }
        },
        hideDropDowns: function() {
            var navbarModel = this.model;
            if (navbarModel.get('search')) {
                this.searchRegion.$el.removeClass('active');
            }
        },
        showSearch: function(e) {
            e.stopPropagation();
            var active = $(e.currentTarget).hasClass('active');
            this.hideDropDowns();
            if (!active) {
                var analyticsId = e.currentTarget.getAttribute('analytics-id');
                this.trigger('analytics:track', 'Click Interactive Bar', analyticsId, 'interacted');
                $(e.currentTarget).addClass('active');
                $('#search_box').focus();
            }
        },
        onUpdateFilterQuery: function(query) {
            this.showLoader();
            var url = this.initialUrl + query;
            this.fetchCollection(url);
        },
        fetchCollection: function(url) {
            var _this = this;
            var collection = App.widget.currentView.collection;
            this.hideControls();
            $('.load_more').hide();
            $('#results_count').hide();
            collection._originalModels = null;
            collection.paginator_core.url = url;
            collection.url = function() {
                return url;
            };
            collection.goTo(1, {
                reset: {
                    silent: true
                },
                processData: true,
                success: function(collection, textStatus, options) {
                    this.fetchCount = 0;
                    this.trigger('check:location:filter');
                    $('.load_more').show();
                }.bind(this),
                error: function(collection, textStatus, options) {
                    if (this.fetchCount < 5) {
                        this.fetchCount++;
                        this.fetchCollection(collection.paginator_core.url);
                    } else {
                        $('.clearfix').addClass('no_photos_view');
                        this.fetchCount = 0;
                    }
                }.bind(this)
            });
        },
        onSync: function() {
            var widgetType = this.model.get('widgetType');
            var horizontalOrCoverflow = widgetType.indexOf('coverflow') !== -1 || widgetType.indexOf('horizontal') !== -1;
            this.hideLoader();
            this.showControls();
            if (this.collection.models.length) {
                $('.clearfix').removeClass('no_photos_view');
                if (horizontalOrCoverflow) {
                    $('.btn').show();
                }
            } else {
                if (!this.firstLoad) {
                    $('.clearfix').addClass('no_photos_view');
                }
                if (horizontalOrCoverflow) {
                    $('.btn').hide();
                }
            }
            this.firstLoad = false;
            this.trigger('update:results:bar:counter', this.collection.models.length);
            $('#results_count').show();
        },
        showLoader: function() {
            $('.clearfix').removeClass('no_photos_view').addClass('loading_content_spinner');
        },
        hideLoader: function() {
            $('.clearfix').removeClass('loading_content_spinner');
        },
        hideControls: function() {
            $('.controls').hide();
        },
        showControls: function() {
            $('.controls').show();
        },
        templateHelpers: function() {
            return {
                getClasses: function() {
                    var classes = '';
                    var filters = this.sort || this.categories || this.seasons;
                    classes += filters ? 'filters' : '';
                    classes += this.search ? ' search ' : '';
                    classes += this.location ? ' location' : '';
                    classes = classes.replace(/  +/g, ' ').trim();
                    return classes;
                }
            };
        }
    });

    NavbarMobile.Interactive = App.Views.Layout.extend({
        template: require('./templates/_interactive_mobile_lightbox.jst.ejs'),
        id: 'interactive_section',
        regions: {
            primaryCategoriesRegion: '#categories_region_1',
            secondaryCategoriesRegion: '#categories_region_2',
            tertiaryCategoriesRegion: '#categories_region_3',
            seasonsRegion: '#seasons_region',
            personalizationRegion: '#personalization_region',
            sortRegion: '#sort_region'
        },
        ui: {
            resetAllButton: '#reset_all_button',
            backButton: '#back_button',
            applyButton: '#apply_button',
            categoryContainer: '.filter_wrapper.categories',
            seasonsRegion: '#seasons_region',
            personalizationRegion: '#personalization_region',
            sortRegion: '#sort_region'
        },
        events: {
            'click @ui.categoryContainer': 'showDropDown',
            'click @ui.seasonsRegion': 'showDropDown',
            'click @ui.personalizationRegion': 'showDropDown',
            'click @ui.sortRegion': 'showDropDown',
            'click @ui.backButton': 'onCloseLightbox',
            'click @ui.resetAllButton': 'resetAll',
            'click @ui.applyButton': 'applyFilters'
        },
        initialize: function(options) {
            this.initialFilters = options.initialFilters;
        },
        applyFilters: function() {
            this.trigger('touch:filter:query');
            this.triggerMethod('close:lightbox');
            this.trigger('update:results:bar:view');
        },
        onCloseLightbox: function() {
            //Do all necessary interactive widget resizing
            var msg = {
                name: 'pixlee:interactive:widget:resize',
                type: 'action',
                source: 'widget',
                destination: 'parent',
                data: {
                    active: false,
                    isPreview: gon.previewMode
                }
            };
            window.parent.postMessage(JSON.stringify(msg), '*');

            //once that's done, then we actually work on removing popup without flicker
            setTimeout(function() {
                //first close it
                var magnificPopup = $.magnificPopup.instance;
                magnificPopup.close();

                //then hide the flicker screen
                msg = {
                    name: 'pixlee:hide:flicker:screen',
                    type: 'action',
                    source: 'widget',
                    destination: 'parent',
                    data: {}
                };
                window.parent.postMessage(JSON.stringify(msg), '*');
            }, 100);
        },
        resetAll: function() {
            this.trigger('uncheck:all:items');
            this.trigger('remove:filter:items', 'category');
            this.trigger('remove:filter:items', 'season');
            this.trigger('remove:filter:items', 'personalization');
            this.trigger('set:sort:to:default');
        },
        onInitializePresetFilters: function() {
            //set the initial filters and close the menu. we set initial filters null so second menu open doesn't
            //re-trigger all of this flow
            this.setInitialNavbarFilters.call(this, JSON.parse(this.initialFilters));
            this.ui.applyButton.click();
            this.initialFilters = null;
        },
        onShow: function() {
            var _this = this;
            var navbarModel = this.model;
            navbarModel.hasInitialFilters = false;
            // https://github.com/js-cookie/js-cookie
            Cookies.json = true;

            //check if there's any initial filters requested make note of it for further action once the regions have rendered
            //we check for string because if no filters are passed through, backbone will automatically pass the jquery
            //event that triggered the view as the first parameter, so a null check will always fail
            navbarModel.hasInitialFilters = typeof this.initialFilters === 'string';

            if (navbarModel.get('personalized')) {
                var cookie = Cookies.get('pixlee_social_cookie') || Cookies.get('pixlee_social_cookie_legacy');
                // Check if logged into social media OR email
                if ((cookie && cookie.social_login && cookie.social_login.social_id) || (cookie && cookie.platform && cookie.social_login)) {
                    var data = cookie;
                    _this.trigger('social:logged:in', data);
                }
            }
            $('#mobile_navbar_lightbox').click(function(e) {
                if (e.target.textContent.trim() !== 'load more content' && !$(e.target).hasClass('img_holder')) {
                    _this.hideDropDowns();
                }
            });
        },
        setInitialNavbarFilters: function(initialFilters) {
            //do something different for each type of filter
            _.each(initialFilters, function(value, name) {
                switch (name) {
                    case 'categories':
                        //check each category region, if it exists and we haven't already found all requested values
                        //the value array is updated within the categories view
                        if (value.length && this.primaryCategoriesRegion.currentView) {
                            this.primaryCategoriesRegion.currentView.triggerMethod('set:initial:categories', value);
                        }
                        if (value.length && this.secondaryCategoriesRegion.currentView) {
                            this.secondaryCategoriesRegion.currentView.triggerMethod('set:initial:categories', value);
                        }
                        if (value.length && this.tertiaryCategoriesRegion.currentView) {
                            this.tertiaryCategoriesRegion.currentView.triggerMethod('set:initial:categories', value);
                        }
                        break;
                    default:
                        break; //just do nothing if param is not recognized
                }
            }.bind(this));
        },
        showDropDown: function(e) {
            e.stopPropagation();
            var _this = this;
            var active = $(e.currentTarget).hasClass('active');
            if ($(e.target).closest('.filter_dropdown').length === 0) {
                this.hideDropDowns();
            }
            if (!active) {
                var analyticsId = e.currentTarget.getAttribute('analytics-id');
                this.trigger('analytics:track', 'Click Interactive Bar', analyticsId, 'interacted');
                $(e.currentTarget).addClass('active');
            }
        },
        hideDropDowns: function() {
            var navbarModel = this.model;
            if (navbarModel.get('categories')) {
                if (!_.isFalsy(this.primaryCategoriesRegion.$el)) {
                    this.primaryCategoriesRegion.$el.removeClass('active');
                }
                if (!_.isFalsy(this.secondaryCategoriesRegion.$el)) {
                    this.secondaryCategoriesRegion.$el.removeClass('active');
                }
                if (!_.isFalsy(this.tertiaryCategoriesRegion.$el)) {
                    this.tertiaryCategoriesRegion.$el.removeClass('active');
                }
            }
            if (navbarModel.get('seasons')) {
                this.seasonsRegion.$el.removeClass('active');
            }
            if (navbarModel.get('personalized')) {
                this.personalizationRegion.$el.removeClass('active');
            }
            if (navbarModel.get('sort')) {
                this.sortRegion.$el.removeClass('active');
            }
        },
        templateHelpers: function() {
            return {
                lessThanFiveDropDowns: function() {
                    var count = 0;
                    count += this.categories ? 1 : 0;
                    count += this.personalized ? 1 : 0;
                    count += this.location ? 1 : 0;
                    count += this.seasons ? 1 : 0;
                    count += this.sort ? 1 : 0;
                    count += this.search ? 1 : 0;
                    return count < 5;
                }
            };
        }
    });

    NavbarMobile.filterItem = App.Views.ItemView.extend({
        template: require('./templates/_filter_item.jst.ejs'),
        className: 'filter_item_container',
        events: {
            'click .filter_item_clear': 'removeItem'
        },
        removeItem: function() {
            this.trigger('uncheck:item');
            this.model.collection.remove(this.model);
        },
        templateHelpers: function() {
            return {
                isTypeCaption: function() {
                    return this.type === 'caption';
                },
                getValue: function() {
                    var value = this.value;
                    if (this.type === 'caption') {
                        if (this.data === 'hashtag') {
                            value = 'Hashtag: #' + value;
                        } else if (this.data === 'userhandle') {
                            value = 'Username: @' + value;
                        } else {
                            value = 'Caption: "' + value + '"';
                        }
                    }
                    return value;
                }
            };
        }
    });

    NavbarMobile.resultsBar = App.Views.CompositeView.extend({
        childView: NavbarMobile.filterItem,
        childViewContainer: '#filter_item_region',
        template: require('./templates/_results_bar.jst.ejs'),
        id: 'results_bar',
        collectionEvents: {
            'add': 'onSync',
            'remove': 'onSync',
            'reset': 'onSync',
            'change': 'onSync',
        },
        ui: {
            resultsCounter: '#results_count',
            clearAllButton: '#clear_all_button'
        },
        events: {
            'click #clear_all_button': 'clearAll'
        },
        onShow: function() {
            this.triggerMethod('update:display');
        },
        onSync: function() {
            this.trigger('touch:filter:query');
        },
        onUpdateDisplay: function() {
            if (this.collection.length) {
                $(this.el).show();
                this.render();
            } else {
                $(this.el).hide();
            }
        },
        onUpdateResultsCounter: function(photoCount) {
            this.ui.resultsCounter.text(photoCount);
        },
        clearAll: function() {
            this.collection.reset();
            if (this.model.get('location')) {
                this.trigger('reset:map:view');
            }
            if (this.model.get('search')) {
                this.trigger('clear:filter:view');
            }
            this.triggerMethod('update:display');
        },
        templateHelpers: function() {
            return {
                getWidgetType: function() {
                    return this.widgetType;
                }
            };
        }
    });

    NavbarMobile.Search = App.Views.CompositeView.extend({
        template: require('./templates/_search.jst.ejs'),
        id: 'search_box_holder',
        ui: {
            searchBox: '#search_box',
            clearSearch: '#clear_search',
            searchBoxHolder: '#search_box_holder'
        },
        events: {
            'keyup #search_box': 'keyUp',
            'click #clear_search': 'clearSearch'
        },
        keyUp: function(e) {
            // e.keyCode === 13 (ENTER)
            if (e.keyCode === 13) {
                var data = '';
                var caption = $(e.currentTarget).val().trim();
                if (caption.charAt(0) === '@') {
                    data = 'userhandle';
                    caption = caption.replace(/[^0-9a-zA-Z_.-]/gi, '');
                } else if (caption.charAt(0) === '#') {
                    data = 'hashtag';
                    // remove '#' and spaces from string
                    caption = caption.replace(/[\s#]/g, '');
                } else {
                    data = 'caption';
                }
                this.ui.clearSearch.addClass('active');
                this.$el.parent().removeClass('active');
                this.ui.searchBox.blur();
                if (caption.length > 0) {
                    this.trigger('add:filter:item', 'search-item', 'caption', caption, data);
                } else {
                    this.ui.clearSearch.removeClass('active');
                    this.trigger('remove:filter:items', 'caption');
                }
                this.trigger('touch:filter:query');
            }
            // e.keyCode === 27 (ESC)
            else if (e.keyCode === 27) {
                this.$el.parent().removeClass('active');
                this.ui.searchBox.blur();
            }
            if (this.ui.searchBox.val().length) {
                this.$el.parent().addClass('has_text');
            } else {
                this.$el.parent().removeClass('has_text');
            }
        },
        clearSearch: function(e) {
            e.stopPropagation();
            this.ui.searchBox.val('');
            this.ui.clearSearch.removeClass('active');
            this.$el.parent().removeClass('active');
            this.$el.parent().removeClass('has_text');
            this.ui.searchBox.blur();
            this.trigger('remove:filter:items', 'caption');
            this.trigger('touch:filter:query');
        },
        onClearSearchView: function() {
            this.ui.searchBox.val('');
            this.ui.clearSearch.removeClass('active');
            this.$el.parent().removeClass('active');
            this.$el.parent().removeClass('has_text');
        },
    });

    NavbarMobile.categoryItem = App.Views.ItemView.extend({
        template: require('./templates/_category_item.jst.ejs'),
        tagName: 'li',
        className: 'dropdown_list_item',
        initialize: function() {
            //if the same category is added to multiple dropdowns, need unique DOM ids
            this.uniqueViewId = _.random(100, 1000);
        },
        templateHelpers: function() {
            return {
                randomId: function() {
                    return this.uniqueViewId;
                }.bind(this)
            };
        }
    });

    NavbarMobile.Categories = App.Views.CompositeView.extend({
        childView: NavbarMobile.categoryItem,
        childViewContainer: '.category_item_region',
        template: require('./templates/_categories.jst.ejs'),
        className: 'filter_container',
        id: 'filter_categories',
        events: {
            'click .check_mark': 'setCategory',
            'click .reset_filter': 'resetFilter'
        },
        ui: {
            checkedItems: '.checked_items',
            resetFilter: '.reset_filter'
        },
        initialize: function() {
            this.itemsChecked = 0;
        },
        onShow: function() {
            this.trigger('check:category:filter');
        },
        onFilterCollectionChange: function(categoriesSelected) {
            // when this fires, the UI may not be rendered yet, this will check if it's rendered
            // before trying to access jQuery functions
            if (!_.isString(this.ui.resetFilter)) {
                this.ui.resetFilter.toggleClass('none_selected', _.isFalsy(categoriesSelected));
            }
        },
        onCheckItems: function(models) {
            _.each(models, function(itemId, i, list) {
                this.$el.find('input[data-id="' + itemId + '"]').prop('checked', true);
            }, this);
            this.itemsChecked = this.$el.find('input:checked').length;
            this.setItemsChecked();
        },
        onSetInitialCategories: function(categoriesSelected) {
            this.$el.find(':checkbox').each(function(i, item) {
                var currItem = $(item);
                var id = +currItem.attr('data-id'); //parse to int
                var name = currItem.attr('name');
                var catIndex = categoriesSelected.indexOf(id);

                //if this category is one of the selected ones, set it and remove it from the
                //array of categoriesSelected. since it's passed by reference the parent will know
                //it was found and not look in other dropdown menus
                if (catIndex !== -1) {
                    currItem.prop('checked', true);
                    this.itemsChecked += 1;
                    categoriesSelected.splice(catIndex, 1);

                    this.trigger('add:filter:item', id, 'category', name, this.options.name, true);
                    this.setItemsChecked();
                }

            }.bind(this));

        },
        setCategory: function(e) {
            var name = e.currentTarget.getAttribute('name');
            var id = parseInt(e.currentTarget.getAttribute('data-id'));
            if (this.options.categoriesSelectOne) {
                this.$el.find(':checkbox').each(function(i, item) {
                    if (item !== this) {
                        $(item).prop('checked', false);
                    }
                }.bind(e.currentTarget));
                this.itemsChecked = e.currentTarget.checked ? 1 : 0;
            } else {
                this.itemsChecked += e.currentTarget.checked ? 1 : -1;
            }
            this.trigger('add:filter:item', id, 'category', name, this.options.name);
            this.setItemsChecked();
        },
        setItemsChecked: function() {
            if (this.itemsChecked === 0) {
                this.ui.checkedItems.text('');
            } else {
                this.ui.checkedItems.text('(' + this.itemsChecked + ')');
            }
        },
        onUncheckAllItems: function() {
            this.$el.find(':checkbox').each(function(i, item) {
                $(item).prop('checked', false);
            });
            this.itemsChecked = 0;
            this.setItemsChecked();
        },
        resetFilter: function() {
            this.trigger('remove:filter:items', 'category');
            this.triggerMethod('uncheck:all:items');
        },
        onUncheckItem: function(itemId) {
            this.$el.find('input[data-id="' + itemId + '"]').prop('checked', false);
            this.itemsChecked--;
            this.setItemsChecked();
        },
        templateHelpers: function() {
            var _this = this;
            return {
                categoryName: function() {
                    return _this.options.name || 'Categories';
                }
            };
        }
    });

    NavbarMobile.Location = App.Views.CompositeView.extend({
        template: require('./templates/_location.jst.ejs'),
        id: 'filter_location',
        className: 'filter_container'
    });

    NavbarMobile.Map = App.Views.ItemView.extend({
        template: require('./templates/_map.jst.ejs'),
        id: 'map_container',
        collectionEvents: {
            'reset': 'onSync'
        },
        ui: {
            searchBox: '#pac-input',
            mapDirections: '#map_directions'
        },
        modelEvents: {
            'change:location_active': 'checkInitMap'
        },
        events: {
            'click #clear_map': 'clearMap',
            'click': 'preventClose'
        },
        onResetMapView: function() {
            this.map.panBy(0.001, 0.001);
            this.map.panTo({
                lat: 15,
                lng: 0
            });
            this.map.setZoom(1);
            this.ui.searchBox.val('');
            this.ui.mapDirections.removeClass('has_filters');
        },
        clearMap: function() {
            this.trigger('remove:filter:items', 'location');
            this.triggerMethod('reset:map:view');
        },
        preventDestroy: function(e) {
            e.stopPropagation();
        },
        onShow: function() {
            this.photoLocations = this.options.photoLocations;
            this.photoLocations.once('sync', function() {
                this.checkInitMap();
            }.bind(this));
        },
        initialize: function(options) {
            this.markers = [];
            this.initialMarkers = false;
        },
        onSync: function() {
            if (this.model.get('location_active')) {
                this.trigger('render:map:markers');
            }
        },
        checkInitMap: function() {
            if (this.model.get('location_active') && _.isFalsy(this.map)) {
                this.onInitMap();
            }
        },
        onInitMap: function() {
            var _this = this;
            var mapOptions = {
                zoom: 1,
                minZoom: 1,
                maxZoom: 9,
                streetViewControl: false,
                mapTypeControl: false,
                center: {
                    lat: 15,
                    lng: 0
                }
            };

            this.map = new google.maps.Map(document.getElementById('map_canvas'), mapOptions);
            var pacInput = document.getElementById('pac-input');

            // To solve conflict with FastClick and PAC (location drop down suggestions) for mobile and tablet
            $(document).on({
                'DOMNodeInserted': function() {
                    $('.pac-item, .pac-item span', this).addClass('needsclick');
                }
            }, '.pac-container');

            // Function for automatically selecting first location on google's auto-complete
            // store the original event binding function
            var _addEventListener = (pacInput.addEventListener) ? pacInput.addEventListener : pacInput.attachEvent;

            function addEventListenerWrapper(type, listener) {
                // Simulate a 'down arrow' keypress on hitting 'return' when no pac suggestion is selected,
                // and then trigger the original listener.
                if (type === "keydown") {
                    var orig_listener = listener;
                    listener = function(event) {
                        var suggestion_selected = $(".pac-item-selected").length > 0;
                        if (event.which === 13 && !suggestion_selected) {
                            var simulated_downarrow = $.Event("keydown", {
                                keyCode: 40,
                                which: 40
                            });
                            orig_listener.apply(pacInput, [simulated_downarrow]);
                        }
                        orig_listener.apply(pacInput, [event]);
                    };
                }
                _addEventListener.apply(pacInput, [type, listener]);
            }

            pacInput.addEventListener = addEventListenerWrapper;
            pacInput.attachEvent = addEventListenerWrapper;

            var searchBox = new google.maps.places.SearchBox(pacInput);

            this.map.addListener('bounds_changed', function() {
                searchBox.setBounds(this.getBounds());
            });

            searchBox.addListener('places_changed', function() {
                var place = searchBox.getPlaces()[0];
                if (_.isFalsy(place)) {
                    return;
                }
                var bounds = new google.maps.LatLngBounds();
                if (place.geometry.viewport) {
                    // Only geocodes have viewport.
                    bounds.union(place.geometry.viewport);
                } else {
                    bounds.extend(place.geometry.location);
                }
                this.map.fitBounds(bounds);
                google.maps.event.addListenerOnce(this.map, 'idle', function() {
                    // very small delay for pac-input value to stop changing via the google autocomplete API
                    setTimeout(function() {
                        var locationName = document.getElementById('pac-input').value;
                        var bounds = this.map.getBounds();
                        var swLat = bounds.getSouthWest().lat();
                        var swLng = bounds.getSouthWest().lng();
                        var neLat = bounds.getNorthEast().lat();
                        var neLng = bounds.getNorthEast().lng();
                        this.ui.mapDirections.addClass('has_filters');
                        this.trigger('add:filter:item', 'location-item', 'location', 'Near: ' + locationName, [swLat, swLng, neLat, neLng]);
                        this.trigger('analytics:track', 'Apply Interactive Bar', 'location', {
                            searchPlace: true,
                            clickOnIcon: false,
                            place: locationName
                        });
                    }.bind(this), 150);
                }.bind(this));
            }.bind(this));
            // Set the current viewport for client side filtering
            google.maps.event.addListener(this.map, 'idle', function() {
                var viewPort = this.getBounds();
                _this.model.set({
                    map_viewport: viewPort
                });
            });
        },
        clearOverlays: function() {
            for (var i = 0; i < this.markers.length; i++) {
                this.markers[i].setMap(null);
            }
            this.markers = [];
        },
        filterByPhotoIds: function(photosIds) {
            this.collection.interactiveWidgetFilterBy(photosIds);
        },
        onRenderMarkers: function(renderInitialMarkers) {
            var _this = this;
            if (renderInitialMarkers && this.initialMarkers) {
                return;
            }
            this.clearOverlays();
            if (!_.isFalsy(this.markerCluster)) {
                this.markerCluster.clearMarkers();
            }

            this.fullBounds = new google.maps.LatLngBounds();
            var styles = [{
                url: 'https://assets.pxlecdn.com/images/embed/common/droppin_cluster.png',
                height: 70,
                width: 39,
                anchorText: [-20, 0],
                textColor: '#ffffff',
                textSize: 12
            }];

            var imageUrl = 'https://assets.pxlecdn.com/images/embed/common/droppin.png';
            var markerImage = new google.maps.MarkerImage(imageUrl, new google.maps.Size(17, 22));

            // Render the world view Initial Markers from distillery-analytics end point
            if (renderInitialMarkers) {
                this.initialMarkers = true;
                this.currentPhotos = this.photoLocations;
            } else {
                this.initialMarkers = false;
                this.currentPhotos = this.collection;
            }

            var photoId = 0;
            _.each(this.currentPhotos.models, function(photo) {
                var id = photo.get('id') || photoId++;
                var submissionsCount = photo.get('submissions_count') || 1;
                var latitude = photo.get('latitude');
                var longitude = photo.get('longitude');
                var location = photo.get('location') || photo.get('locality') + ', ' + photo.get('country');
                if (!_.isFalsy(longitude) && !_.isFalsy(latitude) && !_.isFalsy(submissionsCount)) {
                    _(submissionsCount).times(function(n) {
                        var latLng = new google.maps.LatLng(latitude, longitude);
                        var marker = new google.maps.Marker({
                            position: latLng,
                            icon: markerImage,
                            photoId: id++,
                            locationName: location
                        });
                        _this.markers.push(marker);
                        _this.fullBounds.extend(latLng);
                        // Handle clicks for single markers
                        google.maps.event.addListener(marker, 'click', function() {
                            event.stopPropagation();
                            _this.currentMarkerLocation = marker.locationName;
                            _this.map.setZoom(7);
                            _this.map.panBy(0.001, 0.001);
                            _this.map.panTo(marker.getPosition());
                            google.maps.event.addListenerOnce(this.map, 'idle', function() {
                                var locationName = _this.currentMarkerLocation;
                                var bounds = _this.map.getBounds();
                                var swLat = bounds.getSouthWest().lat();
                                var swLng = bounds.getSouthWest().lng();
                                var neLat = bounds.getNorthEast().lat();
                                var neLng = bounds.getNorthEast().lng();
                                _this.ui.searchBox.val(locationName);
                                _this.ui.mapDirections.addClass('has_filters');
                                _this.trigger('add:filter:item', 'location-item', 'location', 'Near: ' + locationName, [swLat, swLng, neLat, neLng]);
                                _this.trigger('analytics:track', 'Apply Interactive Bar', 'location', {
                                    searchPlace: false,
                                    clickOnIcon: true,
                                    place: locationName
                                });
                            });
                        });
                    });
                }
            });

            this.markerCluster = new MarkerClusterer(this.map, this.markers, {
                styles: styles,
                gridSize: 12,
                zoomOnClick: false,
                averageCenter: true,
                minClusterSize: 2,
                maxZoom: 9
            });

            this.markerCluster.setCalculator(function(markers, numStyles) {
                var count = markers.length;
                var markerText = count;
                if (count > 25) {
                    markerText = '25+';
                }
                return {
                    text: markerText,
                    index: 0
                };
            });

            // Handle clicks for clusters
            this.markerCluster.addListener('clusterclick', function(cluster) {
                event.stopPropagation();
                _this.currentMarkerLocation = cluster.getMarkers()[0].locationName;
                // Keeping these variables around to be able to tweak the map later
                var bounds = cluster.bounds_;
                var center = cluster.center_;
                var maxZoom = _this.map.maxZoom;
                var minZoom = 7;
                var currentZoom = _this.map.zoom;
                _this.clearOverlays();
                _this.markerCluster.clearMarkers();
                _this.map.panBy(0.001, 0.001);
                _this.map.fitBounds(bounds);
                if (_this.map.zoom > 7) {
                    _this.map.setZoom(7);
                }
                google.maps.event.addListenerOnce(this.map, 'idle', function() {
                    var locationName = _this.currentMarkerLocation;
                    var bounds = _this.map.getBounds();
                    var swLat = bounds.getSouthWest().lat();
                    var swLng = bounds.getSouthWest().lng();
                    var neLat = bounds.getNorthEast().lat();
                    var neLng = bounds.getNorthEast().lng();
                    _this.ui.searchBox.val(locationName);
                    _this.ui.mapDirections.addClass('has_filters');
                    _this.trigger('add:filter:item', 'location-item', 'location', 'Near: ' + locationName, [swLat, swLng, neLat, neLng]);
                });
            });
            this.trigger('sync:widget');
        }
    });

    NavbarMobile.Seasons = App.Views.CompositeView.extend({
        template: require('./templates/_seasons.jst.ejs'),
        id: 'filter_season',
        className: 'filter_container',
        events: {
            'click .check_mark': 'setSeason',
            'click .reset_filter': 'resetFilter'
        },
        ui: {
            checkedItems: '.checked_items'
        },
        initialize: function() {
            this.itemsChecked = 0;
        },
        onCheckItems: function(models) {
            _.each(models, function(itemId, i, list) {
                this.$el.find('input[data-id="' + itemId + '"]').prop('checked', true);
            }, this);
            this.itemsChecked = models.length;
            this.setItemsChecked();
        },
        setSeason: function(e) {
            var name = e.currentTarget.getAttribute('name');
            var id = e.currentTarget.getAttribute('data-id');
            this.trigger('add:filter:item', id, 'season', name);
            this.itemsChecked += e.currentTarget.checked ? 1 : -1;
            this.setItemsChecked();
        },
        onUncheckAllItems: function() {
            this.$el.find(':checkbox').each(function(i, item) {
                $(item).prop('checked', false);
            });
            this.itemsChecked = 0;
            this.setItemsChecked();
        },
        setItemsChecked: function() {
            if (this.itemsChecked === 0) {
                this.ui.checkedItems.text('');
            } else {
                this.ui.checkedItems.text('(' + this.itemsChecked + ')');
            }
        },
        resetFilter: function() {
            this.trigger('remove:filter:items', 'season');
            this.triggerMethod('uncheck:all:items');
        },
        onUncheckItem: function(itemId) {
            this.$el.find('input[data-id="' + itemId + '"]').prop('checked', false);
            this.itemsChecked--;
            this.setItemsChecked();
        }
    });

    NavbarMobile.Personalization = App.Views.CompositeView.extend({
        template: require('./templates/_personalization.jst.ejs'),
        id: 'filter_personalization',
        className: 'filter_container',
        events: {
            'click @ui.login': 'login',
            'click @ui.checkMark': 'setPersonalization',
            'click @ui.resetFilter': 'resetFilter',
            'click @ui.logout': 'logout',
            'click @ui.loginItem': 'loginItemClick'
        },
        ui: {
            loadingSocialAuth: '#loading_social_auth',
            socialLogin: '.social_login',
            friendsPhotos: '.friends_photos',
            logout: '.sign_out',
            login: '.social_login_button',
            myPhotosCheckBox: '#my_photos',
            friendsPhotosCheckBox: '#friends_photos',
            photosNearMeCheckBox: '#photos_near_me',
            resetFilter: '.reset_filter',
            checkedItems: '.checked_items',
            loginItem: '.login_item',
            checkMark: '.check_mark'
        },
        initialize: function() {
            this.itemsChecked = 0;

            //check if parent window is http, if so then we can't do location
            this.mixedContentCheck();
        },
        onRender: function() {
            //make sure the ui hash has been built before we try to mess with it
            if (this.insecureDomain && typeof this.ui.photosNearMeCheckBox !== 'string') {
                this.ui.photosNearMeCheckBox.parent().toggle(!this.insecureDomain);
            }
        },
        loginItemClick: function() {
            if (!this.ui.login.is(':hidden')) {
                this.login();
            }
        },
        addGeoLocation: function(id, name, el) {
            var options = {
                enableHighAccuracy: true,
                timeout: 5000,
                maximumAge: 0
            };

            navigator.geolocation.getCurrentPosition(this.geoLocationSuccess.bind(this, id, name, el), this.geoLocationError.bind(this), options);
        },
        geoLocationSuccess: function(id, name, el, pos) {
            var crd = pos.coords;
            this.model.set({
                personalization_longitude: crd.longitude,
                personalization_latitude: crd.latitude
            });
            el.prop('checked', !el.prop('checked'));
            el.removeClass('loading');
            this.trigger('add:filter:item', id, 'personalization', name);
            this.itemsChecked += el.prop('checked') ? 1 : -1;
            this.setItemsChecked();
        },
        geoLocationError: function(err) {
            this.model.set({
                personalization_longitude: '',
                personalization_latitude: ''
            });
            console.warn('ERROR(' + err.code + '): ' + err.message);
        },
        login: function() {
            var _this = this;
            var data = {
                name: 'pixlee:show:social:connect',
                type: 'action',
                source: 'widget',
                destination: 'parent',
                data: {
                    widgetId: window.parentIFrame.getId()
                }
            };

            this.ui.socialLogin.addClass('active');
            this.ui.login.hide();
            window.parent.postMessage(JSON.stringify(data), '*');
            return false;
        },
        logout: function() {
            Cookies.remove('pixlee_social_cookie');
            this.triggerMethod('sign:out');
        },
        onSocialLoginLoaded: function() {
            var _this = this;
            setTimeout(function() {
                _this.ui.socialLogin.removeClass('active');
                _this.ui.login.show();
            }, 1500);
        },
        onSignIn: function(data) {
            //this is called before the view is fully rendered, so no harm in rebinding. "proper" fix is to make sure
            //the controller is childviews in the correct order and waiting for the necessary fetches but that's a lot to
            //track down right no
            this.bindUIElements();

            this.ui.login.hide();
            this.ui.logout.show();
            this.ui.myPhotosCheckBox.prop('disabled', false);
            this.ui.friendsPhotosCheckBox.prop('disabled', false);
            this.ui.resetFilter.removeClass('disabled');
            if (data.platform === 'facebook' || data.platform === 'email') {
                this.ui.friendsPhotos.hide();
            }
        },
        onSignOut: function() {
            this.resetFilter();
            this.ui.logout.hide();
            this.ui.login.show();
            this.ui.friendsPhotos.show();
            this.ui.myPhotosCheckBox.prop('disabled', true);
            this.ui.friendsPhotosCheckBox.prop('disabled', true);
            this.ui.resetFilter.addClass('disabled');
        },
        onSocialLogin: function(data) {
            var _this = this;
            Cookies.set('pixlee_social_cookie', data, { expires: 365 });
            Cookies.set('pixlee_social_cookie_legacy', data, { expires: 365 });
            if (data.social_login) {
                this.model.set({
                    personalization_platform: data.social_login.source || data.platform || '',
                    personalization_access_token: data.social_login.access_token || '',
                    personalization_access_token_secret: data.social_login.access_token_secret || '',
                    personalization_social_id: data.social_login.social_id || data.social_login || '',
                });
                this.triggerMethod('sign:in', data);
            } else {
                this.model.set({
                    personalization_platform: '',
                    personalization_access_token: '',
                    personalization_access_token_secret: '',
                    personalization_social_id: '',
                    personalization_longitude: '',
                    personalization_latitude: ''
                });
                this.triggerMethod('sign:out');
            }
        },
        setPersonalization: function(e) {
            var name = e.currentTarget.getAttribute('name');
            var id = e.currentTarget.getAttribute('data-id');
            if (id === 'near_me') {
                var el = $(e.currentTarget);
                var latitude = this.model.get('personalization_latitude');
                var longitude = this.model.get('personalization_longitude');
                if (!_.isFalsy(latitude) && !_.isFalsy(longitude)) {
                    this.trigger('add:filter:item', id, 'personalization', name);
                    this.itemsChecked += e.currentTarget.checked ? 1 : -1;
                    this.setItemsChecked();
                } else {
                    e.preventDefault();
                    el.addClass('loading');
                    this.addGeoLocation(id, name, el);
                }
            } else {
                this.trigger('add:filter:item', id, 'personalization', name);
                this.itemsChecked += e.currentTarget.checked ? 1 : -1;
                this.setItemsChecked();
            }
        },
        setItemsChecked: function() {
            if (this.itemsChecked === 0) {
                this.ui.checkedItems.text('');
            } else {
                this.ui.checkedItems.text('(' + this.itemsChecked + ')');
            }
        },
        onUncheckAllItems: function() {
            this.$el.find(':checkbox').each(function(i, item) {
                $(item).prop('checked', false);
            });
            this.itemsChecked = 0;
            this.setItemsChecked();
        },
        resetFilter: function() {
            this.trigger('remove:filter:items', 'personalization');
            this.triggerMethod('uncheck:all:items');
        },
        onCheckItems: function(models) {
            _.each(models, function(itemId, i, list) {
                this.$el.find('input[data-id="' + itemId + '"]').prop('checked', true);
            }, this);
            this.itemsChecked = models.length;
            this.setItemsChecked();
        },
        onUncheckItem: function(itemId) {
            this.$el.find('input[data-id="' + itemId + '"]').prop('checked', false);
            this.itemsChecked--;
            this.setItemsChecked();
        },
        mixedContentCheck: function() {
            window.addEventListener('message', this.receiveMessage.bind(this), false);

            var mssg = {
                name: 'pixlee:get:parent:protocol',
                type: 'action',
                source: 'widget',
                destination: 'widget',
                data: {}
            };

            window.parent.postMessage(JSON.stringify(mssg), '*');
        },
        receiveMessage: function(event) {
            var eventData;
            if (event.data) {
                try {
                    eventData = JSON.parse(event.data);
                } catch (error) {
                    return;
                }
            } else {
                return;
            }

            if (eventData.name && eventData.name === 'pixlee:get:parent:protocol') {
                var insecure = eventData.data.protocol === 'http:';

                //if this message arrives before the view renders, set a flag for after render
                if (this.ui.photosNearMeCheckBox.parent) {
                    this.ui.photosNearMeCheckBox.parent().toggle(!insecure);
                } else {
                    this.insecureDomain = true;
                }
            }
        }
    });

    NavbarMobile.Sort = App.Views.CompositeView.extend({
        template: require('./templates/_sort.jst.ejs'),
        id: 'sort',
        className: 'filter_container',
        ui: {
            sortDefault: '#sort_default',
            sortRecency: '#sort_recency',
            sortPopularity: 'sort_popularity',
            sortPriceHighLow: '#sort_price_high_low',
            sortPriceLowHigh: '#sort_price_low_high',
            sortFilterButton: '#sort_filter_button'
        },
        events: {
            'click #sort_default': 'changeSortBy',
            'click #sort_recency': 'changeSortBy',
            'click #sort_popularity': 'changeSortBy',
            'click #sort_price_high_low': 'changeSortBy',
            'click #sort_price_low_high': 'changeSortBy'
        },
        changeSortBy: function(e) {
            e.stopPropagation();
            var currentSortBy = this.model.get('sort_by');
            var targetSortBy = e.currentTarget.id;
            this.ui.sortFilterButton.text(e.target.attributes['dropdown-value'].value);
            this.hideDropDown();
            if (currentSortBy !== targetSortBy) {
                this.model.set({
                    sort_by: targetSortBy
                });
            }
        },
        onSetSortToDefault: function() {
            var targetSortBy = this.ui.sortDefault.attr('id');
            this.ui.sortFilterButton.text(this.ui.sortDefault.attr('dropdown-value'));
            this.model.set({
                sort_by: targetSortBy
            });
        },
        hideDropDown: function() {
            this.$el.parent().removeClass('active');
        },
        templateHelpers: function() {
            return {
                sortRecencyEnabled: function() {
                    return this.sortRecent;
                },
                sortPopularEnabled: function() {
                    return this.sortPopular;
                },
                sortPriceEnabled: function() {
                    return this.sortPrice;
                },
                getDropDownText: function() {
                    switch (this.sort_by) {
                        case 'sort_recency':
                            return 'most recent';
                        case 'sort_popularity':
                            return 'most popular';
                        case 'sort_price_high_low':
                            return 'price | high to low';
                        case 'sort_price_low_high':
                            return 'price | low to high';
                        default:
                            return 'default';
                    }
                }
            };
        }
    });

});
